"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var redirect = function redirect() {
  window.location.href = 'https://www.gainsight.com/resource/iorad/';
};

var ioradPlugin = {
  init: function init(editor) {
    editor.ui.addButton('Iorad', {
      label: 'Iorad',
      command: 'iorad',
      icon: 'iorad',
      toolbar: 'insert,0'
    });
    editor.widgets.add('iorad-widget', {
      upcast: function upcast() {
        return false;
      }
    });
    editor.addCommand('iorad', {
      exec: function exec() {
        (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          var response, data, url;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return fetch('https://www.iorad.com/api/extensionStatus');

                case 3:
                  response = _context.sent;
                  _context.next = 6;
                  return response.json();

                case 6:
                  data = _context.sent;

                  if (data.enabled) {
                    url = new URL(window.location.href);
                    url.searchParams.set('ioradViewDomain', 'true');
                    window.history.pushState({}, '', url);
                  } else {
                    redirect();
                  }

                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](0);
                  redirect();

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 10]]);
        }))();
        return true;
      }
    });
  }
};
var _default = ioradPlugin;
exports.default = _default;